<script>
import {transactionMonitoring as columns} from "../../../tables"

const services = {
  pay: '#135200',
  inq: '#006d75',
  rev: '#9e1068',
  dep: '#0050b3'
}

const statuses = {
  success: '#87d068',
  pending: '#2db7f5',
  failed: '#f50'
}

const prettyMs = require('pretty-ms')

export default {
  computed: {
    filteredService() {
      const s = _.keys(services)
      return s.filter(o => !this.filters.service.includes(o))
    }
  },
  data() {
    return {
      columns,
      statuses,
      services,
      monitoring: true,
      transactions: [],
      enableAlert: false,
      form: this.$form.createForm(this),
      filters: {
        service: [],
        products: [],
        clients: [],
        billers: [],
        max: 30,
      }
    }
  },
  mounted() {
    this.registerListener();
  },
  methods: {
    toggleAlert() {
      this.enableAlert = !this.enableAlert
    },
    registerListener() {
      Echo.private('hyperion-monitoring-transaction')
        .listen('Services.InquiryRequestAccepted', (e) => this.accepted(e))
        .listen('Services.InquirySuccess', (e) => this.update(e, 'success'))
        .listen('Services.InquiryFailed', (e) => this.update(e, 'failed'))
        .listen('Services.PaymentRequestAccepted', (e) => this.accepted(e))
        .listen('Services.PaymentSuccess', (e) => this.update(e, 'success'))
        .listen('Services.PaymentFailed', (e) => this.update(e, 'failed'))
    },
    accepted(event) {
      this.loading = false

      this.transactions.unshift({
        'id': event.transaction.id,
        'type': event.transaction.service_type,
        'client': event.transaction.client.name,
        'client_hash': event.transaction.client.hash,
        'subscriber_id': event.transaction.subscriber_id,
        'product': event.product.name,
        'status': 'pending',
        'elapsed': null,
        'created_at': new Date()
      })

      if (this.transactions.length > this.filters.max)
        this.transactions.pop()
    },
    update(event, status) {
      let trx = this.transactions.find(item => item.id === event.transaction.id)
      if (trx !== 'undefined') {
        trx.status = status
        trx.elapsed = prettyMs(new Date().getTime() - trx.created_at.getTime())
      }

      if (this.enableAlert && status === 'failed')
        document.getElementById('alertSound').play()
    }
  }
}
</script>

<template>
  <a-card size="small" type="inner">
    <div slot="extra">
      <a-tooltip title="Enable/Disable Alarm">
        <a-button size="small"
                  :type="enableAlert ? 'default' : 'dashed'"
                  shape="circle"
                  icon="sound"
                  @click="toggleAlert()"></a-button>
      </a-tooltip>
      <audio id="alertSound" style="display: none;" v-bind:muted="enableAlert === false">
        <source type="audio/ogg" src="/assets/audio/alert.ogg">
        <source type="audio/mp3" src="/assets/audio/alert.mp3">
      </audio>
    </div>

    <a-table :columns="columns" :dataSource="transactions" :pagination="false" rowKey="id">
      <div slot="service" slot-scope="service">
        <h4 :style="{ color: services[service] }">{{ service.toUpperCase() }}</h4>
      </div>

      <h4 slot="client" slot-scope="row">
        {{ row.client }}
        <a-button type="link" icon="link" :href="routeUri('hyperion.client.show', { client_hash: row.client_hash })"/>
      </h4>


      <div slot="product" slot-scope="row">
        <h4>{{ row.product }}</h4>
      </div>

      <div slot="transaction" slot-scope="id,record" class="copyable">
        <h5>
          {{ record.subscriber_id }}
          <a-button size="small" type="link" @click="copy(record.subscriber_id)" icon="copy"/>
        </h5>

        <span>
          <a :href="routeUri('hyperion.transaction.show', { transaction_uuid: record.id })"><code>{{ record.id }}</code></a>
          <a-button size="small" type="link" icon="copy" @click="copy(record.id)"/>
        </span>
      </div>

      <span slot="status" slot-scope="status" :style="{textAlign: 'center'}">
            <a-tag :color="statuses[status]">
                {{ status.toUpperCase() }}
            </a-tag>
      </span>

      <span slot="elapsed" slot-scope="elapsed" v-if="elapsed !== null">
                {{ elapsed }}
            </span>
    </a-table>
  </a-card>
</template>
